import React, {Component} from 'react'
import EmptyLastUploadedImg from "../../assets/images/empty-last-uploaded.png";
import "./EmptyLastUploaded.css";

export class EmptyLastUploaded extends Component {
    render(){
        return (
            <div
                className='empty-last-uploaded-wrapper'
            >
                <img 
                    className='empty-last-uploaded-img'
                    src={EmptyLastUploadedImg} 
                    alt="empty" 
                />
                <p
                    className='empty-last-uploaded-p'
                >
                    Aquí aparecerá el último<br/>contenido subido a la cuenta
                </p>
            </div>
        )
    }
}

export default EmptyLastUploaded;